import { initiatePromotionMiddleware } from "./initiate-promotion-middleware";

export const organizationMiddleware = [initiatePromotionMiddleware];
